<template>
  <div class="recognized-by__wrapper">
    <h2>PROUDLY RECOGNIZED BY</h2>

    <homepage-recognized-by-carousel class="recognized-by__carousel" />
  </div>
</template>

<script>
import HomepageRecognizedByCarousel from '@/components/_homepage/HomepageRecognizedBySection/HomepageRecognizedByCarousel/index.vue'
import { generateServerCacheKey } from '@/plugins/helper'

export default {
  name: 'HomepageRecognizedBySection',
  serverCacheKey: () => generateServerCacheKey('HomepageRecognizedBySection'),
  components: { HomepageRecognizedByCarousel }
}
</script>

<style lang="scss" scoped>
.recognized-by__wrapper {
  .recognized-by__carousel {
    $margin-right: (
      $above-desktop-xl: -#{$padding-x-desktop-full-hd},
      $desktop-sm: -#{$padding-x-desktop-sm},
      $mobile: -#{$padding-x-mobile}
    );

    $margin-top: (
      $above-desktop-xl: 47px,
      $desktop-sm: 10px,
      $mobile: 10px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
    @include setStyleByBreakpoint('margin-right', $margin-right);
  }
}
</style>
